import * as THREE from "three";

export function ColorArrayToTHREEColor(colorArray: number[]|n, interpretNullAsWhite = true): THREE.Color {
	if (colorArray == null) {
		if (interpretNullAsWhite) {
			return new THREE.Color("white"); // white has effect of just keeping the texture color
			//return new THREE.Color(1, 1, 1); // white color
		}
		throw new Error("Color array cannot be null or undefined.");
	}
	if (colorArray.length < 3) {
		throw new Error("Color array must have at least 3 elements (R, G, B).");
	}

	const result = colorArray.slice(0, 3);
	// if color has alpha channel, interpret it as "how much to use this color to colorize the texture"
	if (colorArray.length >= 4) {
		const alpha = colorArray[3];
		for (let i = 0; i < 3; i++) {
			result[i] = 255 - (result[i].Distance(255) * alpha)
		}
	}

	//return new THREE.Color(...result.map(a=>a / 256));
	/*const color = new THREE.Color();
	// we use setStyle+rgbString rather than the constructor+numberArray, in order to have threejs auto-convert from sRGB space (css) to linear space (3js)
	color.setStyle(`rgb(${result[0]}, ${result[1]}, ${result[2]})`);
	return color;*/
	// we use css-string rather than number-array, so that threejs auto-converts from sRGB space (css) to linear space (3js)
	// (and round to integer, otherwise 3js fails to parse the color-string)
	return new THREE.Color(`rgb(${result[0].RoundTo(1)}, ${result[1].RoundTo(1)}, ${result[2].RoundTo(1)})`);
}